/** Options for the Difficulty Level dropdown in the contribute form */
export const DIFFICULTY_OPTIONS = ["Beginner", "Intermediate", "Advanced"];

// TODO: replace with /metadata endpoint
/** Options for the Impact Indicator dropdown in the contribute form */
export const IMPACT_INDICATOR_OPTIONS = [
  "Time savings",
  "Cost reduction",
  "Quality improvement",
  "Risk reduction",
  "Customer satisfaction",
  "Employee experience",
  "Innovation enablement",
  "Other",
];

/** Number of pages shown in the video and article pagination controls */
export const USE_CASES_PAGINATION_PAGE_COUNT = 5;

/** Max width of the hero content column on the browse page (matches the 800px search bar width in Figma) */
export const USE_CASES_HERO_CONTENT_MAX_WIDTH = "900px";

/** Placeholder community stats shown in the browse page hero until live data is wired up */
export const USE_CASES_COMMUNITY_STATS = {
  useCases: 248,
  contributors: 54,
  aiTools: 12,
};

/** Query parameter key used on the use cases browse page to filter by use case type */
export const USE_CASE_TYPE_QUERY_PARAM = "type";

/** Values for the USE_CASE_TYPE_QUERY_PARAM query parameter */
export enum UseCaseType {
  Video = "video",
  Article = "article",
}

/** Sort option definitions mapping UI labels to backend fields */
export const USE_CASE_SORT_OPTIONS = [
  { label: "Best Match", field: undefined, direction: undefined },
  { label: "Popularity", field: "usedCount", direction: "desc" },
  { label: "Newest", field: "publishedAt", direction: "desc" },
  { label: "Most Viewed", field: "viewCount", direction: "desc" },
  { label: "Most Commented", field: "commentCount", direction: "desc" },
] as const;

/** Number of use case cards displayed per pagination page */
export const USE_CASES_CARDS_PER_PAGE = 6;

/** Number of items fetched per API request */
export const USE_CASES_API_PAGE_SIZE = 20;

/** Debounce delay (ms) before triggering a search after filter/query changes */
export const USE_CASES_SEARCH_DEBOUNCE_MS = 150;

/** Path to the earth illustration shown on the "view more" card */
export const EARTH_ILLUSTRATION_PATH = "/img/earth.svg";

/** Path to the cat illustration shown in empty states */
export const CAT_ILLUSTRATION_PATH = "/img/Illustration-Cat.svg";

/** URL query parameter keys for the use cases browse page */
export enum UseCaseBrowseQueryParams {
  QUERY = "query",
  SORT = "sort",
  CATEGORIES = "categories",
  AUDIENCE = "audience",
}

/** UxM touchpoint names for interactions on the use cases browse page */
export enum UseCaseBrowseTouchpoint {
  Search = "aiforme-useCasesBrowse-searchInput-typed",
  Contribute = "aiforme-useCasesBrowse-contributeButton-clicked",
  Dashboard = "aiforme-useCasesBrowse-dashboardButton-clicked",
  FilterJobFamily = "aiforme-useCasesBrowse-jobFamilyFilter-selected",
  FilterCategories = "aiforme-useCasesBrowse-categoriesFilter-selected",
  Sort = "aiforme-useCasesBrowse-sortDropdown-selected",
  ExploreAllVideos = "aiforme-useCasesBrowse-exploreAllVideosLink-clicked",
  ExploreAllArticles = "aiforme-useCasesBrowse-exploreAllArticlesLink-clicked",
  CollapseSection = "aiforme-useCasesBrowse-sectionExpander-toggled",
}

/** UxM touchpoint names for interactions on the contributor dashboard page */
export enum UseCaseDashboardTouchpoint {
  BrowseUseCases = "aiforme-useCasesDashboard-browseUseCasesButton-clicked",
  ExploreTools = "aiforme-useCasesDashboard-contributeToolButton-clicked",
  StartContributing = "aiforme-useCasesDashboard-startContributingButton-clicked",
  TabUseCases = "aiforme-useCasesDashboard-useCasesTab-clicked",
  TabAiTools = "aiforme-useCasesDashboard-aiToolsLink-clicked",
  UseCaseCardClick = "aiforme-useCasesDashboard-useCaseCard-clicked",
}

/** Dashboard tab identifiers */
export enum DashboardTab {
  UseCases = "useCases",
  AiTools = "aiTools",
}
